var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAggregator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.16666H5C3.88843 2.16666 3 3.05549 3 4.14166V13.2333C3 14.3195 3.88843 15.2083 5 15.2083H5.63333C6.42932 15.2083 7.1902 15.517 7.75248 16.0787C7.75284 16.0791 7.7532 16.0794 7.75355 16.0798L9.17626 17.4858C9.63147 17.9352 10.3766 17.9353 10.8319 17.486L15 2.16666ZM15 2.16666C16.1116 2.16666 17 3.05549 17 4.14166V13.2333C17 14.3195 16.1116 15.2083 15 15.2083H14.375C13.5882 15.2083 12.8188 15.5164 12.2559 16.0787C12.2555 16.0791 12.2551 16.0794 12.2548 16.0798L10.8321 17.4858L15 2.16666ZM6.66024 10.9624L6.65993 10.9629C6.06595 11.8472 6.68418 13.05 7.76667 13.05H12.2333C13.303 13.05 13.9366 11.851 13.3401 10.9629L13.3398 10.9624C12.6667 9.96274 11.3991 9.33332 10 9.33332C8.60095 9.33332 7.33329 9.96274 6.66024 10.9624ZM12.4417 6.73332C12.4417 5.38218 11.3511 4.29166 10 4.29166C8.64886 4.29166 7.55833 5.38218 7.55833 6.73332C7.55833 8.07473 8.64746 9.17499 10 9.17499C11.3511 9.17499 12.4417 8.08447 12.4417 6.73332Z",
    fill: "#86A7C3",
    stroke: "#86A7C3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAggregator);
export default __webpack_public_path__ + "static/media/aggregator.90e6c71f.svg";
export { ForwardRef as ReactComponent };